<template>
  <div class="detail">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <BaseInfoForm
            :isDisabledForm="isDisabledForm"
            :fetchData="formData"
            @changeGoods="changeGoods"
            @changeCategory="changeCategory"
            ref="baseInfoFormRef"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            质物信息
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs v-model="tabName" type="card">
            <el-tab-pane label="质物信息" name="pledgeInfo">
              <PledgeTable
                ref="pledgeTableRef"
                :showTableBtn="showTableBtn"
                :tableDataList="collateralLst"
                :disabledGoods="isDisabledGoods"
                :goodsList="goodsList"
                :billId="id"
                :billStatus="contractStatus"
                :categoryList="categoryList"
                @changeQuantity="changeQuantity"
                @closeEdit="closeEdit"
              />
            </el-tab-pane>
            <el-tab-pane
              label="抽检信息"
              name="samplingInfo"
              v-if="!['01', '10', '11'].includes(formData.billStatus)"
            >
              <SampleingTable
                ref="samplingTableRef"
                :tableDataList="samplingInfoList"
                :collateralLst="collateralLst"
              />
            </el-tab-pane>
            <el-tab-pane label="审批记录" v-if="isShowApprovalRecordTable" name="approvalRecord">
              <ApprovalRecordTable
                ref="approvalRecordRef"
                :fetchTableData="approvalList"
              ></ApprovalRecordTable>
            </el-tab-pane>
            <el-tab-pane label="历史记录" v-if="isShowHistoryExecuteTable" name="historyExecute">
              <HistoryExecuteTable
                ref="historyExecuteRef"
                :fetchTableData="historyList"
              ></HistoryExecuteTable>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable ref="fileTableRef" :isShowDownBtn="isShowDownBtn" :attachments="attachments" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="4" v-if="isShowApprovalTable">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            监管单审批
          </div>
        </template>
        <div class="collapse-content">
          <BillApprovalForm
            ref="billApprovalFormRef"
            :billNo="billNo"
            :reason="formData.frozeReason"
          />
        </div>
      </el-collapse-item>
      <!-- 底部按钮 -->
      <footer class="bottomButtons">
        <DetailFooterButtons
          @btnHandler="btnHandler"
          :billStatus="formData.billStatus"
          :status="currentStatus"
        ></DetailFooterButtons>
      </footer>
    </el-collapse>
  </div>
</template>

<script>
  import BaseInfoForm from './components/BaseInfoForm/index.vue';
  import PledgeTable from './components/PledgeTable/index.vue';
  import FileTable from '@/components/business/FileTable/index.vue';
  import ApprovalRecordTable from './components/ApprovalRecordTable/index.vue';
  import HistoryExecuteTable from './components/HistoryExecuteTable/index.vue';
  import DetailFooterButtons from './components/DetailFooterButtons.vue';
  import BillApprovalForm from './components/BillApprovalForm/index.vue';
  import superviseBillApi from '@/api/park/superviseBill';
  import btnGroupMixin from './btnGroupMixin';
  import SampleingTable from './components/SamplingTable/index.vue';
  export default {
    name: 'supervisionBillDetail',
    mixins: [btnGroupMixin],
    data() {
      return {
        activeNames: ['1', '2', '3', '4'],
        currentStatus: 'detail',
        tabName: 'pledgeInfo',
        isShowDownBtn: false,
        isDisabledForm: true,
        showTableBtn: false,
        isShowApprovalTable: false,
        isShowApprovalRecordTable: true,
        isShowHistoryExecuteTable: true,
        isDisabledGoods: true,
        id: null,
        billNo: '',
        contractStatus: '',
        approvalList: [],
        approvalType: '',
        attachments: [],
        collateralLst: [],
        historyList: [],
        goodsList: '',
        categoryList: '',
        formData: {},
        goodsValueFlag: 0,
        samplingInfoList: [], //抽检信息
      };
    },
    mounted() {
      if (this.$route.query?.status) {
        this.currentStatus = this.$route.query?.status;
        if (this.currentStatus == 'approval') {
          this.isShowApprovalTable = true;
          this.isShowApprovalRecordTable = false;
          this.isShowHistoryExecuteTable = false;
          this.isShowDownBtn = true;
        } else if (this.currentStatus == 'edit') {
          this.isDisabledForm = false;
          this.showTableBtn = true;
          this.isDisabledGoods = false;
          this.isShowApprovalRecordTable = false;
          this.isShowHistoryExecuteTable = false;
        } else if (this.currentStatus == 'detail') {
          this.isShowDownBtn = true;
        }
      }
      this.id = this.$route.query?.id;
      if (this.id) {
        this.initPageData(this.id);
      }
      if (this.$route.query?.operateType == 'create') {
        this.approvalType = '01';
      } else if (this.$route.query?.operateType == 'froze') {
        this.approvalType = '02';
      } else if (this.$route.query?.operateType == 'unfroze') {
        this.approvalType = '03';
      } else if (this.$route.query?.operateType == 'release') {
        this.approvalType = '04';
      }
    },
    methods: {
      // 初始化数据
      async initPageData(id) {
        this.isLoading = true;
        const { data } = await this.$axios.post(`${superviseBillApi.GET_BILL_DETAIL_BY_ID}/${id}`);
        console.log(data, '根据id值查询这一行的数据');
        this.isLoading = false;
        if (data.code == 0) {
          const {
            approvalList,
            attachments,
            collateralLst,
            historyList,
            superviseBillChecks,
            ...formData
          } = data.data;
          this.approvalList = approvalList;
          this.attachments = attachments;
          this.collateralLst = collateralLst;
          this.historyList = historyList;
          this.samplingInfoList = superviseBillChecks;
          console.log('samplingInfoList', this.samplingInfoList);
          this.formData = formData;
          if (formData.billStatus == '01' && collateralLst.length == 0) {
            this.goodsList = formData.goodsType;
            this.categoryList = formData.goodsCategory;
          }
          this.billNo = formData.billNo;
          this.contractStatus = formData.billStatus;
        } else {
          console.error('获取数据失败');
        }
      },
      changeGoods(val) {
        if (this.formData.billStatus == '01') {
          this.goodsList = val.toString();
        }
      },
      changeCategory(val) {
        if (this.formData.billStatus == '01') {
          this.categoryList = val.toString();
        }
      },
      changeQuantity(val) {
        console.log('我改变了', val);
        if (val != null) {
          this.formData.contractQuantity = val;
        }
      },
      // 质物信息表格退出编辑状态,获取表格数据
      closeEdit(val) {
        console.log('获取质物信息数据', val);
        this.collateralLst = val;
      },
    },
    components: {
      BaseInfoForm,
      PledgeTable,
      ApprovalRecordTable,
      HistoryExecuteTable,
      DetailFooterButtons,
      BillApprovalForm,
      FileTable,
      SampleingTable,
    },
  };
</script>

<style lang="scss" scoped>
  .bottomButtons {
    padding-top: 20px;
    text-align: center;
  }
</style>
